import { render } from "./SfRouterLink.vue?vue&type=template&id=742b0316&ts=true"
import script from "./SfRouterLink.vue?vue&type=script&lang=ts"
export * from "./SfRouterLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__